import React from 'react';

const StaImage = ( props ) => {
  const outerStyle = {
    width: props.width,
    paddingBottom: props.paddingBottom
  };
  const innerStyle = {
    backgroundImage: "url(" + process.env.GATSBY_DRUPAL_ROOT + props.url + ")"
  };

  return (
    <div className="relative float-left h-0 max-w-full" style={outerStyle}>
      <div className="w-full h-full absolute bg-center bg-no-repeat bg-cover" style={innerStyle}></div>
    </div>
  );
}

export default StaImage;
